import { HttpHelper } from '../helpers/httpHelper';
import { UrlManager } from '../providers/urlManager/urlManager';
import { mockCandidate } from './mockCandidate';

export const candidateApi = {
    getCandidate: (email, mock = false) => {
        if (mock) {
            return new Promise(resolve => setTimeout(() => resolve(mockCandidate), 5000));
        }

        return HttpHelper.fetch(UrlManager.getCandidateUrl(), {
            method: 'GET',
            queryParams: { email },
        });
    },
    getInterviewScheduledData: (mock = false) => {
        if (mock) {
            return new Promise(resolve => setTimeout(() => resolve(mockCandidate), 5000));
        }

        return HttpHelper.fetch(UrlManager.getInterviewScheduledDataUrl(), {
            method: 'GET',
        });
    },
    getCandidatePipeline: (mock = false) => {
        if (mock) {
            return mockCandidate;
        }

        return HttpHelper.fetch(UrlManager.getCandidatePipelineUrl(), {
            method: 'GET',
        });
    },

    updateCandidateStatus: async (id, status) => {
        try {
            const response = await fetch('/candidate_pipeline_status', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id, status }),
            });

            if (!response.ok) {
                throw new Error('Failed to update candidate status');
            }

            return await response.json();
        } catch (error) {
            console.error('Error updating candidate status:', error);
            throw error;
        }
    },
};
